import { useEffect, useRef } from "react";
import { api, can } from "@/lib/api";
import { toast } from "sonner";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const printSpoolStickers = (spools) => {
  if (!spools?.length) return;
  window.open(`${BACKEND}/api/spools/stickers.pdf?ids=${spools.map((s) => s.id).join(",")}`, "_blank");
};

export const toastNewSpools = (spools) => {
  if (!spools?.length) return;
  toast.success(`Diterima · ${spools.length} spool + barcode dibuat (${spools[0].code}${spools.length > 1 ? ` – ${spools[spools.length - 1].code}` : ""})`, {
    duration: 15000, action: { label: "Cetak stiker", onClick: () => printSpoolStickers(spools) },
  });
};

const notify = (title, body) => {
  toast.warning(title, { description: body, duration: 20000 });
  if ("Notification" in window && Notification.permission === "granted") { try { new Notification(title, { body }); } catch { /* ignore */ } }
};

export const ProdTimerWatcher = ({ user }) => {
  const seen = useRef({});
  const ok = can(user, "production");
  useEffect(() => {
    if (!ok) { return; }
    const tick = () => api.get("/prod/timers").then(({ data }) => {
      data.jobs.forEach((j) => {
        const k = j.id + j.run_started_at;
        const s = seen.current[k] || {};
        if (j.remaining_min <= 0 && !s.done) {
          notify(`${j.machine_name} selesai`, `${j.wo_code} · ${j.file_name} — segera ambil hasilnya`);
          seen.current[k] = { near: true, done: true };
        } else if (j.remaining_min > 0 && j.remaining_min <= data.alert_min && !s.near) {
          notify(`${j.machine_name} hampir selesai`, `${j.wo_code} · ${j.file_name} — sisa ${Math.ceil(j.remaining_min)} menit`);
          seen.current[k] = { ...s, near: true };
        }
      });
    }).catch(() => {});
    tick();
    const t = setInterval(tick, 60000);
    return () => { clearInterval(t); };
  }, [ok]);
  return null;
};
